import React from "react";

const Declaimer = () => {
  return (
    <div className="mx-auto max-w-4xl rounded-lg bg-white p-6 shadow-md">
      <h1 className="mb-4 text-2xl font-bold">Preclinify Disclaimer</h1>

      <h2 className="mb-2 text-xl font-semibold">1. Limitation of Liability</h2>
      <p className="mb-4">
        1.1 Preclinify is a website designed for all medical professionals and
        students. Preclinify is not intended as a replacement for your
        clinician, or a diagnostic tool for patients, and should not be used as
        such. The Content on Our Site does not constitute advice on which you
        should rely. It is provided for general information purposes only.
        Professional or specialist advice should always be sought before taking
        any action relating to diagnostics, management, and medical procedures.
        Therefore, by using this site, you agree: all users are advised to refer
        to drug manufacturers literature or the British National Formulary
        before administering any of the drugs mentioned on this website;
        Preclinify is not liable to you or any third party for any claim, loss
        or damages arising out of your use of the site or its materials; your
        reliance upon Preclinify materials is solely at your own risk; whilst we
        make reasonable efforts to ensure that the Content on Our Site is
        complete, accurate, and up-to-date, we do not, however, make any
        representations, warranties or guarantees (whether express or implied)
        that the Content is complete, accurate, or up-to-date.
      </p>
      <p className="mb-4">
        1.2 As a professional user, you are responsible for taking all
        precautions you believe are necessary or advisable to protect you from
        any claim, damage, or loss that may arise from your use of
        Preclinify.com.
      </p>
      <p className="mb-4">
        1.3 We are not responsible for the content or accuracy, or for any views
        expressed in any Posts submitted by Users. Any such views or content
        represent the views and values of the relevant User, and do not reflect
        Our views and values in any way.
      </p>
      <p className="mb-4">
        1.4 We make no representation, warranty, or guarantee that Our Site will
        meet your requirements, that it will not infringe the rights of third
        parties, that it will be compatible with all software and hardware, or
        that it will be secure. If, as a result of Our failure to exercise
        reasonable care and skill, any digital content from Our Site damages
        your device or other digital content belonging to you and you are a
        consumer, you may be entitled to certain legal remedies.
      </p>
      <p className="mb-4">
        1.5 Whilst we exercise all reasonable skill and care to ensure that Our
        Site is secure and free of errors, viruses, and other malware, you are
        strongly advised to take responsibility for your own internet security,
        that of your personal details, and your computers.
      </p>

      <h2 className="mb-2 text-xl font-semibold">2. Rights Copyright Notice</h2>
      <p className="mb-4">
        2.1 You acknowledge and agree that Preclinify may contain proprietary
        intellectual property including trademarks, service marks, and patents
        protected by intellectual property laws and international intellectual
        property treaties. Preclinify authorises you to view and make a single
        copy of portions of its content for offline, personal, non-commercial
        use. Our content may not be sold, reproduced, or distributed without our
        written permission. Any third-party trademarks, service marks, and logos
        are the property of their respective owners. Any further rights not
        specifically granted herein are reserved ©Preclinify. All Rights
        Reserved.
      </p>
      <p className="mb-4">
        2.2 The content of this website is protected by the copyright laws of
        England and Wales and by international laws and conventions. No content
        from this website may be copied, reproduced, or revised without the
        prior written consent of Preclinify. Copies of content may be saved
        and/or printed for personal use only.
      </p>

      <h2 className="mb-2 text-xl font-semibold">3. Images</h2>
      <p className="mb-4">
        3.1 All logos and images used in the navigation of the website,
        including the Preclinify logo and diagrams embedded within articles are
        copyrighted works, and should not be reproduced in any way without prior
        written consent.
      </p>

      <h2 className="mb-2 text-xl font-semibold">
        4. Submitting Content to Preclinify
      </h2>
      <p className="mb-4">
        4.1 We welcome Submissions, for which you will, if accepted, be
        credited. By submitting your content to Preclinify you agree that: You
        will be recognised as the author of your content by name as long as the
        article remains on Preclinify; Your content will be displayed on the
        Preclinify website, and may be distributed in other forms of media
        including, but not limited to; online, mobile applications, printed
        media; You allow Preclinify a worldwide, royalty-free licence to edit,
        reproduce, copy, publicly perform, publicly display, publish, reformat,
        translate, excerpt (in whole or in part), distribute, prepare derivative
        works (including collections) of, incorporate into other works and
        otherwise use your material as best as we see fit; You allow
        advertisements to be placed alongside your content on the Preclinify
        website; You warrant and represent that: Copyright in the Submissions is
        owned solely, exclusively and absolutely by You and You are free to
        license them to Preclinify; No third party has any right, title or
        interest in the Submissions nor has claimed the same at any time prior
        submission. You will indemnify and hold Preclinify harmless against any
        claim, loss, damage, proceedings, settlement, costs or expenses
        howsoever arising, directly or indirectly, as a result of any breach or
        non-performance by You of any of your obligations, undertakings or
        warranties as set out in this Agreement.
      </p>

      <h2 className="mb-2 text-xl font-semibold">5. External Links</h2>
      <p className="mb-4">
        5.1 Preclinify provides links to many external resources, including
        advertisers. Preclinify takes no responsibility for the content of
        external websites. Preclinify reserves the right to amend, alter and
        delete links to external content at any time.
      </p>

      <h2 className="mb-2 text-xl font-semibold">6. Change of terms</h2>
      <p>
        6.1 Preclinify reserves the right to modify these terms from time to
        time at our sole discretion and without any notice. Changes to our terms
        become effective on the date they are posted and your continued use of
        Preclinify after any changes to terms will signify your agreement to be
        bound by them.
      </p>
    </div>
  );
};

export default Declaimer;
